import { Drawer, MenuList } from '@mui/material'
import Box from '@mui/material/Box'
import * as React from 'react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import useHover from '@hooks/useHover'
import Routes from '../../routing/dashboard-routes/routes'
import storage from '@/utils/storage'
import SidebarItem from './sidebar-item'

interface ISidebarProps {}

const drawerWidth = 70

const Sidebar: React.FC<ISidebarProps> = (props) => {
  const [isOpen, setIsOpen] = useState(true)
  const [isHovered, hoversHandlers] = useHover(false)
  const location = useLocation()
  const userRole = storage.getUserRole()
  const isAdmin = storage.getUserAdmin()

  const activeRoute = (routeName: any) => {
    return location.pathname === routeName ? true : false
  }

  const filterByRole = (route: any) => {
    // Special case for Admin Console - show if user isAdmin
    if (route.path === '/admin-console') {
      return isAdmin === true
    }

    // Regular role filtering
    return userRole
      ? route.userRole === userRole || route.userRole === 'both'
      : route.isPublic
  }

  const drawer = (
    <MenuList sx={{ width: '100%', paddingY: 0 }}>
      {Routes.filter((route) => !route.isHidden)
        .filter((route) => filterByRole(route))
        .map((route, key) => (
          <SidebarItem
            key={key}
            route={route}
            isActive={activeRoute(route.path)}
            isHovered={isHovered}
            isMobile={false}
          />
        ))}
    </MenuList>
  )

  return (
    <Box sx={{ display: 'flex' }}>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            overflow: 'hidden',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            transition: 'width .4s',
            '&:hover': {
              width: '250px',
            },
          },
        }}
        {...hoversHandlers}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  )
}

export default Sidebar
